<!--  -->
<template>
  <div class="tabox">
    <div class="tabselecr_box">
      <div class="search_box">
        <!-- <el-input v-model="query.sp_strategy_no" clearable style="width:280px;margin-right:10px" placeholder="请输入策略编号" />
        <el-input v-model="query.sp_strategy_title" clearable style="width:280px;margin-right:10px" placeholder="请输入策略标题" /> -->
        <el-input
          v-model="query.keywords"
          clearable
          style="width: 400px;margin-right: 10px"
          :placeholder="
            push_method == 1 ? '请输入员工id/员工编号' : group_selection == 5 ? '请输入发言人员工编号' : '请输入员工编号'
          "
        />
        <el-date-picker
          v-model="date_time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
        <el-select v-model="query.send_status" placeholder="请选择发送状态">
          <el-option
            v-for="item in send_status_op"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          style="margin-left: 10px"
          @click="searchclick"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="rechargeclick"
        >重置</el-button>
        <el-button
          v-if="push_method == 1 && type != 1"
          type="warning"
          icon="el-icon-folder-add"
          :disabled="selectlist.length == 0"
          @click="batchsendresult"
        >批量更新发送结果</el-button>
        <el-button
          type="primary"
          icon="el-icon-download"
          :loading="exportLoading"
          @click="exportclick"
        >{{ exportButtonText }}</el-button>
        <el-button
          v-if="push_method == 1"
          type="primary"
          icon="el-icon-bell"
          :disabled="!remindableSelectlist.length || batchReminding"
          @click="batchRemindSend"
        >批量提醒员工发送</el-button>
      </div>
      <!-- <div>
        <el-button type="success" icon="el-icon-plus" @click="add">新增策略</el-button>
      </div> -->
    </div>
    <el-table
      v-if="push_method == 1 && type != 1"
      ref="multipleTable"
      v-loading="listLoading"
      :data="tabledata"
      max-height="750"
      :row-key="rowKey"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        width="55"
        :reserve-selection="true"
        :selectable="selectable"
      />
      <el-table-column
        prop="sp_strategy_no"
        width="200"
        label="策略编号"
        align="center"
      />
      <el-table-column
        prop="corp_name"
        width="200"
        label="主体"
        align="center"
      />
      <el-table-column
        prop="user_id"
        width="180"
        label="员工id"
        align="center"
      />
      <el-table-column
        prop="employee_no"
        width="180"
        label="员工编号"
        align="center"
      />
      <el-table-column prop="name" width="80" label="员工名称" align="center" />
      <el-table-column
        prop="msg_id"
        width="200"
        label="群发推送返回编号"
        align="center"
      />
      <el-table-column
        prop="send_count"
        width="80"
        label="群发人数"
        align="center"
      />
      <el-table-column
        prop="remind_count"
        width="80"
        label="提醒成员群发"
        align="center"
      />
      <el-table-column prop="success_count" label="成功数量" align="center">
        <template slot="header">
          <div class="tab-header">
            成功数量
            <el-tooltip
              class="item"
              effect="dark"
              content="推送客户数"
              placement="top"
            >
              <i class="el-icon-warning" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fail_count"
        width="100"
        label="失败数量"
        align="center"
      />
      <el-table-column
        prop="send_time_text"
        width="100"
        label="发送时间"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        width="100"
        label="创建时间"
        align="center"
      />
      <el-table-column
        prop="send_status_text"
        width="200"
        label="发送状态"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <i v-if="scope.row.status == 1" class="el-icon-success defaultr" />
            <i
              v-if="scope.row.status == 2"
              class="el-icon-warning defaultrse"
            />
            {{ scope.row.send_status_text }}
            <el-button
              v-if="scope.row.send_status === 0"
              size="mini"
              type="primary"
              @click="remindsend(scope.row)"
            >提醒员工发送</el-button>
            <!-- <el-button v-if="scope.row.send_status === 2" size="mini" type="primary" @click="getsendrealut(scope.row)">获取发送结果</el-button> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" width="200">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="备注"
            width="200"
            trigger="hover"
            :content="scope.row.remark"
          >
            <p slot="reference" class="titip">{{ scope.row.remark }}</p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="send_time_text"
        width="150"
        label="操作"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.send_status === 2"
            size="mini"
            type="primary"
            @click="lookinfo(scope.row)"
          >查看详情</el-button>
          <el-button
            v-if="scope.row.send_status === 0"
            size="mini"
            type="primary"
            @click="getsendrealut(scope.row)"
          >更新发送结果</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-if="push_method == 2 && type != 1"
      v-loading="listLoading"
      :data="tabledatar"
      max-height="750"
      border
    >
      <el-table-column
        prop="sp_strategy_no"
        width="250"
        label="策略编号"
        align="center"
      />
      <el-table-column
        prop="group_chat_id"
        width="300"
        label="群id"
        align="center"
      />
      <el-table-column
        prop="group_chat_name"
        width="300"
        label="群名称"
        align="center"
      />
      <el-table-column
        prop="employee_no"
        width="250"
        :label="group_selection == 5 ? '发言人员工编号' : '员工编号'"
        align="center"
      />
      <el-table-column
        prop="name"
        width="150"
        :label="group_selection == 5 ? '发言人员工名称' : '员工名称'"
        align="center"
      />
      <el-table-column
        prop="send_time_text"
        width="200"
        label="发送时间"
        align="center"
      />
      <el-table-column
        prop="send_count"
        width="100"
        label="群发人数"
        align="center"
      />
      <el-table-column prop="success_count" label="成功数量" align="center">
        <template slot="header">
          <div class="tab-header">
            成功数量
            <el-tooltip
              class="item"
              effect="dark"
              content="只代表消息条数"
              placement="top"
            >
              <i class="el-icon-warning" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="fail_count"
        width="100"
        label="失败数量"
        align="center"
      /> -->
      <el-table-column
        prop="send_count"
        width="150"
        label="发送状态"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.send_status === 0">
            <i class="el-icon-warning" style="color: #ebb563" />未发送
          </div>
          <div v-if="scope.row.send_status === 1">
            <i class="el-icon-success" style="color: #67c23a" />已发送
          </div>
          <div v-if="scope.row.send_status === 2">
            <i class="el-icon-error" style="color: #f56c6c" />发送异常
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" width="200">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="备注"
            width="200"
            trigger="hover"
            :content="scope.row.remark"
          >
            <p slot="reference" class="titip">{{ scope.row.remark }}</p>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-if="type == 1"
      v-loading="listLoading"
      :data="tabledatathree"
      max-height="750"
      border
    >
      <el-table-column
        prop="name"
        label="姓名(公司名称)"
        max-width="300"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.employee_name }}（{{ scope.row.corp_name }}）
        </template>
      </el-table-column>
      <el-table-column
        prop="employee_no"
        label="员工编号"
        max-width="260"
        align="center"
      />
      <el-table-column
        prop="sp_strategy_no"
        label="策略编号"
        max-width="260"
        align="center"
      />

      <el-table-column
        prop="job_no"
        label="任务编号"
        max-width="260"
        align="center"
      />

      <el-table-column
        prop="send_time_day"
        label="发送日期"
        max-width="230"
        align="center"
      />
      <el-table-column
        prop="send_time_hi"
        label="发送时间"
        max-width="100"
        align="center"
      />
      <el-table-column label="进度" align="center" max-width="260">
        <template slot-scope="scope">
          <el-progress
            :text-inside="true"
            :stroke-width="20"
            :percentage="
              parseInt(
                scope.row.send_count == 0 && scope.row.total == 0
                  ? '0%'
                  : ((scope.row.send_count + scope.row.fail_count) /
                    scope.row.total) *
                    100
              )
            "
            status="success"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="total"
        label="总数"
        max-width="100"
        align="center"
      />
      <el-table-column
        prop="send_count"
        label="成功"
        max-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <i class="el-icon-success defaultr" />
          {{ scope.row.send_count }}
        </template>
      </el-table-column>
      <el-table-column label="失败" max-width="100" align="center">
        <template slot-scope="scope">
          <i class="el-icon-error stopew" />
          {{ scope.row.fail_count }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="detail(scope.row.job_no)"
          >详情</el-button>
          <el-button v-show="scope.row.re_invite_button" type="default" size="mini" @click="onClickReInvite(scope.row.job_no)">重邀发言人</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="详情"
      :visible.sync="dialogsendinfo"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="73%"
    >
      <sendinfo ref="sendinfoview" />
    </el-dialog>
    <el-dialog
      title="客户发送记录详情"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      width="70%"
    >
      <pushdetailsDialog ref="pushdetailsview" />
    </el-dialog>
    <el-dialog
      title="批量提醒发送中"
      :visible.sync="batchRemindDialogVisible"
      :close-on-click-modal="false"
      width="560px"
      @close="onBatchRemindDialogClose"
    >
      <div class="batch-remind-content">
        <p>总共提醒 {{ batchRemindTotal }}个员工发送,</p>
        <div ref="batchRemindLog" class="batch-remind-log">
          <p v-for="(log, index) in batchRemindLogs" :key="index">
            正在提醒员工{{ log.name }}({{ log.employee_no }})发送， 请求结果<span :class="log.success ? 'remind-success' : 'remind-fail'">{{ log.success ? '成功' : '失败' }}</span><span v-if="!log.success && log.message" class="remind-fail">，{{ log.message }}</span>
          </p>
          <p v-if="batchReminding && batchRemindCurrent">
            正在提醒员工{{ batchRemindCurrent.name }}({{ batchRemindCurrent.employee_no }})发送...
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="batchReminding" @click="batchRemindDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <pagination-right
      :current-page="query.page"
      :total="total"
      :page-sizes="[10,30,50,100]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import {
  tacticssend,
  spgetSentresult,
  remindCorpUserToSendMsg,
  thirdPartyPushRecords,
  strategyscriptPushRecord,
  reinvite,
  timingPushRecordsExport
} from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import sendinfo from './sendinfo.vue'
import pushdetailsDialog from '../../pushCustomscript/components/pushdetailsDialog.vue'
export default {
  components: { PaginationRight, sendinfo, pushdetailsDialog },
  data() {
    return {
      query: {
        sp_strategy_no: null,
        keywords: null,
        page: 1,
        page_size: 10,
        created_begin: null,
        created_end: null,
        send_status: null
      },
      send_status_op: [],
      group_selection: null,
      send_status_option: [
        {
          value: null,
          label: '全部'
        }, {
          value: '0',
          label: '未发送'
        }, {
          value: '2',
          label: '已经发送'
        }
      ],
      send_status_option_thr: [
        {
          value: null,
          label: '全部'
        }, {
          value: '0',
          label: '未发送'
        }, {
          value: '1',
          label: '已经发送'
        }, {
          value: '2',
          label: '发送异常'
        }
      ],
      dialogsendinfo: false,
      listLoading: false,
      tabledata: [],
      sendid: null,
      total: null,
      push_method: null,
      tabledatar: [],
      tabledatathree: [],
      type: null,
      selectlist: [],
      selectlistsend: [],
      dialogVisible: false,
      date_time: null,
      batchRemindDialogVisible: false,
      batchRemindLogs: [],
      batchRemindTotal: 0,
      batchReminding: false,
      batchRemindCurrent: null,
      exportLoading: false,
      exportCountdown: 0,
      exportTimer: null
    }
  },
  computed: {
    exportButtonText() {
      if (!this.exportLoading) return '导出'
      return this.exportCountdown > 0
        ? `正在导出，请等待${this.exportCountdown}秒`
        : '正在导出，请稍候'
    },
    remindableSelectlist() {
      return (this.selectlist || []).filter(item => item.send_status === 0)
    }
  },
  watch: {
    date_time(val) {
      if (val && val.length === 2) {
        this.query.created_begin = val[0]
        this.query.created_end = val[1]
      } else {
        this.query.created_begin = null
        this.query.created_end = null
      }
    }
  },
  created() {
    console.log(this.$route.query, '数据')
    this.query.sp_strategy_no = this.$route.query.id
    this.push_method = this.$route.query.push_method
    this.group_selection = this.$route.query.group_selection
    console.log('this.push_method', this.push_method)
    if (this.$route.query.type === 1) {
      this.type = this.$route.query.type
      this.pushnewlist()
      return
    }
    // eslint-disable-next-line eqeqeq
    if (this.push_method == 1) {
      this.list()
      this.send_status_op = []
      this.send_status_op = [...this.send_status_option]
    } else {
      this.alllist()
      this.send_status_op = []
      this.send_status_op = [...this.send_status_option_thr]
    }
  },
  mounted() {},
  beforeDestroy() {
    this.clearExportCountdown()
  },
  methods: {
    rowKey(row) {
      return row.id
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    },
    async list() {
      this.listLoading = true
      const data = await tacticssend(this.query)
      this.tabledata = data.data.list
      this.total = data.data.total
      this.listLoading = false
      console.log('data', data)
    },
    async alllist() {
      this.listLoading = true
      const data = await thirdPartyPushRecords(this.query)
      this.tabledatar = data.data.list
      this.total = data.data.total
      this.listLoading = false
    },
    async pushnewlist() {
      this.listLoading = true
      const data = await strategyscriptPushRecord(this.query)
      this.tabledatathree = data.data.list
      this.total = data.data.total
      this.listLoading = false
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.query.page = 1
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        this.pushnewlist()
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.push_method == 1) {
        this.list()
      } else {
        this.alllist()
      }
    },
    fetchCurrentPage(e) {
      this.query.page = e
      if (this.type === 1) {
        this.pushnewlist()
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.push_method == 1) {
        this.list()
      } else {
        this.alllist()
      }
    },
    lookinfo(item) {
      console.log(item)
      this.dialogsendinfo = true
      this.$nextTick(() => {
        this.$refs.sendinfoview.send(item)
      })
    },
    searchclick() {
      this.query.page = 1
      if (this.type === 1) {
        this.pushnewlist()
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.push_method == 1) {
        this.list()
      } else {
        this.alllist()
      }
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.query.created_begin = null
      this.query.created_end = null
      this.date_time = null
      // this.query.sp_strategy_no = null
      // this.query.sp_strategy_title = null
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        this.pushnewlist()
        return
      }
      if (this.push_method === 1) {
        this.list()
      } else {
        this.alllist()
      }
    },
    async remindsend(item) {
      try {
        await remindCorpUserToSendMsg({ id: item.id })
        this.$message({
          message: '提醒员工发送成功',
          type: 'success'
        })
        this.list()
      } catch (err) {
        console.log(err)
      }
    },
    getRemindErrorMessage(err) {
      if (!err) return '未知错误'
      if (err.response && err.response.data && err.response.data.message) {
        return err.response.data.message
      }
      if (err.message && err.message !== 'Error') {
        return err.message
      }
      if (typeof err === 'string') {
        return err
      }
      return '提醒失败'
    },
    async batchRemindSend() {
      const list = this.remindableSelectlist
      if (!this.selectlist.length) {
        this.$message.warning('请先勾选要提醒的员工')
        return
      }
      if (!list.length) {
        this.$message.warning('勾选的员工均已发送，无法批量提醒')
        return
      }
      this.batchRemindLogs = []
      this.batchRemindTotal = list.length
      this.batchRemindDialogVisible = true
      this.batchReminding = true
      for (const item of list) {
        this.batchRemindCurrent = {
          name: item.name || '',
          employee_no: item.employee_no || ''
        }
        let success = false
        let message = ''
        try {
          await remindCorpUserToSendMsg({ id: item.id })
          success = true
        } catch (err) {
          success = false
          message = this.getRemindErrorMessage(err)
        }
        this.batchRemindLogs.push({
          name: item.name || '',
          employee_no: item.employee_no || '',
          success,
          message
        })
        this.$nextTick(() => {
          const logEl = this.$refs.batchRemindLog
          if (logEl) {
            logEl.scrollTop = logEl.scrollHeight
          }
        })
      }
      this.batchRemindCurrent = null
      this.batchReminding = false
      this.selectlist = []
      this.$refs.multipleTable.clearSelection()
    },
    onBatchRemindDialogClose() {
      this.list()
    },
    async getsendrealut(item) {
      const data = await spgetSentresult({
        ids: [item.id]
        // user_id: item.user_id,
        // msg_id: item.msg_id
      })
      this.$message({
        message: `${data.message}`,
        type: 'success'
      })
      this.list()
    },
    updatar() {},
    async batchsendresult() {
      console.log('this.selectlist', this.selectlist)
      this.selectlistsend = []
      this.selectlistsend = this.selectlist.map((item, index) => {
        // eslint-disable-next-line eqeqeq
        return item.id
      })
      console.log('this.selectlistsend', this.selectlistsend)
      const data = await spgetSentresult({
        ids: this.selectlistsend
      })
      this.$message({
        message: `${data.message}`,
        type: 'success'
      })
      this.selectlistsend = []
      this.selectlist = []
      this.$refs.multipleTable.clearSelection()
      setTimeout(() => {
        this.list()
      }, 3000)
    },
    selectable(row, index) {
      // eslint-disable-next-line eqeqeq
      return row.send_status != 2 // 通过某个值来进行判断，规定那一行的选择框被禁用
    },
    detail(job_no) {
      console.log('job_no', job_no)
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.pushdetailsview.send(job_no)
      })
    },
    onClickReInvite(jobNo) {
      this.$confirm(
        '确认要重邀该发言人吗？', // 提示内容
        '提示', // 标题
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          // 用户点了「确定」才调用实际逻辑
          this.reInvite(jobNo)
        })
        .catch(() => {
          // 用户点了「取消」或关闭弹窗，这里不用处理
        })
    },
    async reInvite(job_no) {
      const data = await reinvite({ job_no: job_no })
      console.log(data)
      if (data.code === 200) {
        this.$message({
          message: '重邀成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: data.message,
          type: 'success'
        })
      }
    },
    clearExportCountdown() {
      clearInterval(this.exportTimer)
      this.exportTimer = null
      this.exportCountdown = 0
      this.exportLoading = false
    },
    async exportclick() {
      if (this.exportLoading) return
      const { ...exportParams } = this.query
      this.exportLoading = true
      try {
        const res = await timingPushRecordsExport(exportParams)
        if (!this.exportLoading) return // 离开页面后不再启动下载计时。
        const { url } = res.data
        if (!url) throw new Error('未获取到导出文件地址')
        const readyAt = Date.now() + 20000
        this.exportCountdown = 20
        this.exportTimer = setInterval(() => {
          this.exportCountdown = Math.max(0, Math.ceil((readyAt - Date.now()) / 1000))
          if (this.exportCountdown === 0) {
            this.clearExportCountdown()
            window.open(url, '_blank')
          }
        }, 1000)
      } catch (err) {
        this.clearExportCountdown()
        this.$message.error(err.message || '导出失败')
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tabox {
  padding: 30px;
}
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.search_box {
  flex-wrap: wrap;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.titip {
  width: 180px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* 这里是超出几行省略 */
  overflow: hidden;
}
.batch-remind-content p {
  margin: 0 0 8px;
}
.batch-remind-log {
  max-height: 320px;
  overflow-y: auto;
}
.batch-remind-log p {
  line-height: 1.8;
  margin: 0;
}
.remind-success {
  color: #67c23a;
}
.remind-fail {
  color: #f56c6c;
}
</style>
